/**
 * Boot: read runtime config (window.__WINDROP_CONFIG__ from /config.js, loaded ahead of this module — no
 * inline scripts, CSP `script-src 'self'`), preconnect the API, install analytics + vitals, register the
 * service worker (prod), mount the app.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/app.css';
import { App } from './app';
import { installAnalytics } from './lib/analytics';
import { preconnectApi } from './lib/config';
import { registerServiceWorker } from './lib/pwa';
import { createQueryClient } from './lib/query';
import { startVitals } from './lib/vitals';
import { createAppRouter } from './router';

preconnectApi();
installAnalytics();
registerServiceWorker();

const router = createAppRouter();
startVitals({
  // Route pattern, not the concrete URL (no slugs / ids in telemetry).
  route: () =>
    router.state.matches
      .map((m) => m.route.path ?? '')
      .filter(Boolean)
      .join('/')
      .replace(/\/+/g, '/') || '/',
});

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App router={router} queryClient={createQueryClient()} />
    </StrictMode>,
  );
}
